
import React from 'react';
import { motion } from 'framer-motion';
import { Plane, User, ArrowRight, ArrowLeft } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { getCityName } from '@/components/airportUtils';

export default function RoundtripFlightCard({ flights }) {
  if (!flights || flights.length < 2) return null;

  const outbound = flights[0];
  const returnTrip = flights[1];
  
  // Find the flight that contains the price to get the ticket price.
  const flightWithPrice = flights.find(f => f.total_price && f.total_price > 0);
  const totalPrice = flightWithPrice ? flightWithPrice.total_price : null;

  const formatTime12Hour = (timeString) => {
    if (!timeString) return 'N/A';
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const FlightLeg = ({ flight, isReturn = false }) => (
    <div className="flex items-center gap-4 py-3">
      <div className="flex items-center gap-2 w-32 text-sm" style={{color: 'var(--text-secondary)'}}>
        {isReturn ? <ArrowLeft className="w-4 h-4" /> : <ArrowRight className="w-4 h-4" />}
        <span>{isReturn ? 'Return' : 'Outbound'}</span>
      </div>
      <div className="flex-1 flex items-center justify-between">
        <div className="text-left">
          <p className="font-semibold text-white">{formatTime12Hour(flight.departure_time)}</p>
          <p className="text-xs" style={{color: 'var(--text-muted)'}}>{getCityName(flight.departure_city)}</p>
        </div>
        <div className="flex-1 mx-4 text-center">
          <Plane className="w-4 h-4 inline-block" style={{color: 'var(--text-muted)'}}/>
        </div>
        <div className="text-right">
          <p className="font-semibold text-white">{formatTime12Hour(flight.arrival_time)}</p>
          <p className="text-xs" style={{color: 'var(--text-muted)'}}>{getCityName(flight.arrival_city)}</p>
        </div>
      </div>
    </div>
  );

  return (
    <motion.div
      className="glass rounded-2xl p-5 hover-glow"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="flex items-start justify-between mb-2">
        <div>
          <h3 className="text-lg font-semibold text-white">{outbound.marketing_airline}</h3>
          <p className="text-sm" style={{color: 'var(--text-muted)'}}>Roundtrip Flight</p>
        </div>
        {totalPrice && (
            <div className="text-right">
                <p className="text-2xl font-bold" style={{color: 'var(--accent-color)'}}>
                    ${totalPrice.toLocaleString()}
                </p>
                <p className="text-xs" style={{color: 'var(--text-muted)'}}>Ticket Price</p>
            </div>
        )}
      </div>

      <div className="divide-y divide-white/10">
        <FlightLeg flight={outbound} />
        <FlightLeg flight={returnTrip} isReturn={true} />
      </div>
    </motion.div>
  );
}
